export const COOKIE_CONSENT_CATEGORIES = {
    /**
     * Category for 'performance' cookies, used for preferences, eg: language.
     * The values of the keys should map to CookieConsent categories, as defined in the configuration object.
     */
    NECESSARY: 'necessary',
    PERFORMANCE: 'performance',
};
